import { FaFacebookSquare, FaInstagram, FaLinkedin } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io5";
import { FaGithub, FaXTwitter } from "react-icons/fa6";

export function FooterPortafolio({profile}) {
    return (
        <footer className="footer-profile mt-4">
            <div className="footer-profile__container col-lg-8 m-auto">
                <ul className="footer-profile__list d-flex justify-content-center">
                    <ItemRSS
                        icon={<FaGithub />}
                        link={profile.linkGitHub} />
                    <ItemRSS
                        icon={<FaLinkedin />}
                        link={profile.linkLinkedin} />
                    <ItemRSS
                        icon={<FaXTwitter />}
                        link={profile.linkX} />
                    <ItemRSS
                        icon={<FaInstagram />}
                        link={profile.linkInstagram} />
                    <ItemRSS
                        icon={<FaFacebookSquare />}
                        link={profile.linkFacebook} />
                    <ItemRSS
                        icon={<IoLogoWhatsapp />}
                        link={profile.linkWhatsapp} />
                </ul>
                <div className="footer-profile__copyright d-flex justify-content-center">
                    <Copyright
                        text={profile.copyright} />
                </div>
            </div>
        </footer>
    );
}

export function ItemRSS({ icon, link }) {
    return (
        <li className="footer__item rounded d-flex align-items-center">
            <a className="footer__link p-2 d-flex" href={link} target="_blank" rel="noopener noreferrer">
                {icon}
            </a>
        </li>
    );
}

export function Copyright({text}) {
    return(
        <div className="copyright mb-4">{text}</div>
    );
}